/* eslint-disable */
import { useState, useEffect } from 'react';
import { useDispatch } from 'react-redux';

import history from 'routes/history';
import actionLoader from 'store/modules/loader/actions';
import { GET_ADMIN_LOGIN } from 'services/Admin';
import { LOGIN, LOGOUT, LOGIN_WITH_TOKEN } from 'services/Login';
import { GET_SSO_LOGIN } from 'services/Sso';

const useAuth = () => {
  const dispatch = useDispatch();

  const [loaderShowing, setShowLoader] = useState(false);
  const [userData, setUserData] = useState({
    atualizarDados: false,
    jwtToken: null,
    userId: null,
    authenticated: false,
    nome: null,
    regionalId: null,
    aprovaUsuario: false,
  });

  useEffect(() => {
    async function autoLogin() {
      const loginUserData = JSON.parse(localStorage.getItem('midias_brf'));
      if (loginUserData) {
        const data = JSON.stringify(loginUserData);
        localStorage.setItem(
          'midias_brf', data);
      }

      setUserData(loginUserData);
    }
    autoLogin();
  }, []);

  async function handleLogin({ username, password, redirect }) {
    showLoader(true);

    const {
      value: { authenticated, nome, userId, regionalId, atualizarDados, aprovaUsuario },
      jwtToken,
    } = await LOGIN({ username, password });
    const sso = false;

    localStorage.setItem(
      'midias_brf',
      JSON.stringify({
        jwtToken,
        userId,
        authenticated,
        nome,
        regionalId,
        atualizarDados,
        aprovaUsuario,
      })
    );
    localStorage.setItem('token', jwtToken);
    setUserData({
      jwtToken,
      userId,
      authenticated,
      nome,
      regionalId,
      atualizarDados,
      aprovaUsuario,
    });
    showLoader(false);
    if (authenticated === true) {
      history.push(redirect);
    }
    return authenticated;
  }

  async function handleSSOLogin({ email, redirect }) {
    showLoader(true);

    const {
      value: { authenticated, nome, userId, regionalId, atualizarDados, aprovaUsuario },
      jwtToken,
    } = await GET_SSO_LOGIN({ email });
    const sso = true;

    localStorage.setItem(
      'midias_brf',
      JSON.stringify({
        jwtToken,
        userId,
        authenticated,
        nome,
        regionalId,
        atualizarDados,
        aprovaUsuario,
      })
    );
    localStorage.setItem('token', jwtToken);
    setUserData({
      jwtToken,
      userId,
      authenticated,
      nome,
      regionalId,
      atualizarDados,
      aprovaUsuario,
    });
    showLoader(false);
    if (authenticated === true) {
      history.push(redirect);
    }
    return authenticated;
  }

  async function handleLogout() {
    showLoader(true);
    await LOGOUT();
    localStorage.removeItem('midias_brf');
    setUserData({
      atualizarDados: false,
      jwtToken: null,
      userId: null,
      authenticated: false,
      nome: null,
      regionalId: null,
      aprovaUsuario: false,
    });

    history.replace('/login');
    showLoader(false);
  }

  async function handleSSOLogout(ssoLogout) {
    showLoader(true);
    await LOGOUT();
    localStorage.removeItem('midias_brf');
    setUserData({
      atualizarDados: false,
      jwtToken: null,
      userId: null,
      authenticated: false,
      nome: null,
      regionalId: null,
      aprovaUsuario: false,
    });

    history.replace('/login');
    showLoader(false);

    ssoLogout(); // SSO logout
  }

  async function adminLoginAs(usuarioId, redirect) {
    showLoader(true);

    let response = await GET_ADMIN_LOGIN(usuarioId);

    const {
      value: { authenticated, nome, userId, regionalId, atualizarDados, aprovaUsuario },
      jwtToken,
    } = response;
    const sso = false;

    setLocalStorage({
      jwtToken,
      userId,
      authenticated,
      nome,
      regionalId,
      atualizarDados,
      aprovaUsuario,
    });

    showLoader(false);
    history.push(redirect || '/');
  }

  async function loginWithToken(token) {
    showLoader(true);
    const {
      value: {
        authenticated,
        nome,
        userId,
        regionalId,
        atualizarDados,
        aprovaUsuario,
        urlRedirect,
        error,
      },
      jwtToken,
    } = await LOGIN_WITH_TOKEN({ token: token });

    if (error?.length) {
      history.push('/');
      return;
    }

    const sso = false;
    setLocalStorage({
      jwtToken,
      userId,
      authenticated,
      nome,
      regionalId,
      atualizarDados,
      aprovaUsuario,
    });

    history.push(urlRedirect || '/');
    showLoader(false);
  }

  function setLocalStorage(user) {
    localStorage.setItem('midias_brf', JSON.stringify(user));
    localStorage.setItem('token', user.jwtToken);
    setUserData(user);
  }

  async function showLoader(value) {
    dispatch(actionLoader.showLoader(value));
    setShowLoader(value);
  }

  return {
    loaderShowing,
    showLoader,
    handleLogin,
    handleSSOLogin,
    handleLogout,
    handleSSOLogout,
    userData,
    setUserData,
    adminLoginAs,
    loginWithToken,
  };
};

export default useAuth;
